import { FadeUp } from "@/components/KineticText";
import { CREDENTIALS, IMAGES } from "@/data/profile";

export const Credentials = () => (
  <section data-testid="credentials-section" className="border-t hairline px-6 md:px-12 py-24 md:py-32 bg-[var(--surface)]">
    <div className="grid grid-cols-12 gap-6">
      <div className="col-span-12 md:col-span-3">
        <span className="eyebrow">[ 08 ] Credentials</span>
        <div className="hidden md:block mt-8 aspect-[4/5] overflow-hidden border hairline group">
          <img src={IMAGES.drillBits} alt="PDC and tricone drill bits" loading="lazy" className="img-treat h-full w-full object-cover group-hover:scale-105" />
        </div>
      </div>
      <ul className="col-span-12 md:col-span-8 md:col-start-5 border-t hairline">
        {CREDENTIALS.map((c, i) => (
          <FadeUp key={c} delay={i * 0.05}>
            <li
              data-testid={`credential-${i}`}
              className="flex gap-6 py-5 border-b hairline text-sm md:text-base"
            >
              <span className="eyebrow pt-1 w-8 shrink-0 !text-[var(--accent)]">0{i + 1}</span>
              <span>{c}</span>
            </li>
          </FadeUp>
        ))}
      </ul>
    </div>
  </section>
);
